import { Button } from "@freightsimple/ui-core/Controls/Button";
import { useNavigate } from "react-router-dom";

/**
 * "Get Instant Quotes" as a menu item — where the CTA lives on a phone, since
 * the bar has no room for its label there. Owns the navigation itself (menu
 * items must encapsulate their handler, not receive it via props).
 */
export function NavBarGetQuotesButton() {
  const navigate = useNavigate();
  return (
    <Button
      data-testid="get-quotes-menu-option"
      onClick={() => navigate("/book/details")}
    >
      Get Instant Quotes
    </Button>
  );
}
